import { useScrollReveal } from '@/hooks/useScrollReveal';

const rows = [
  { label: 'Поиск заявок', manual: 'Несколько часов в день', aigam: 'Автоматически' },
  { label: 'Скорость реакции', manual: 'Минуты или часы', aigam: 'Секунды' },
  { label: 'Работа ночью', manual: 'Нет', aigam: 'Да' },
  { label: 'Квалификация лидов', manual: 'Менеджер', aigam: 'ИИ' },
  { label: 'Назначение встреч', manual: 'Менеджер', aigam: 'ИИ' },
  { label: 'Масштабирование', manual: 'Нужны сотрудники', aigam: 'Не требуется' },
];

export default function TLCompare() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1180px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Сравнение
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Ручной поиск vs AIGAM
          </h2>
        </div>

        <div className="mt-12 rounded-2xl border border-background-200 overflow-x-auto">
          <div className="min-w-[640px]">
          <div className="grid grid-cols-3 bg-background-100 border-b border-background-200">
            <div className="px-4 md:px-6 py-4 md:py-5 text-[11px] md:text-[12px] font-semibold uppercase tracking-wider text-foreground-400">Критерий</div>
            <div className="px-4 md:px-6 py-4 md:py-5 text-[13px] md:text-[14px] font-semibold text-foreground-600 border-l border-background-200 flex items-center gap-2">
              <i className="ri-user-line"></i>Ручной поиск
            </div>
            <div className="px-4 md:px-6 py-4 md:py-5 text-[13px] md:text-[14px] font-bold text-background-50 bg-background-950 border-l border-background-950 flex items-center gap-2">
              <i className="ri-sparkling-2-line text-primary-400"></i>AIGAM
            </div>
          </div>
          {rows.map((row, i) => (
            <div
              key={row.label}
              className={`grid grid-cols-3 border-b border-background-200 last:border-b-0 ${i % 2 === 1 ? 'bg-background-100/40' : 'bg-background-50'}`}
            >
              <div className="px-4 md:px-6 py-4 md:py-5 text-[13px] md:text-[15px] font-medium text-foreground-950">{row.label}</div>
              <div className="px-4 md:px-6 py-4 md:py-5 text-[13px] md:text-[14px] text-foreground-500 border-l border-background-200 flex items-center gap-2">
                <i className="ri-close-circle-line text-foreground-400 shrink-0"></i>
                <span>{row.manual}</span>
              </div>
              <div className="px-4 md:px-6 py-4 md:py-5 text-[13px] md:text-[14px] font-semibold text-foreground-900 bg-primary-50/50 border-l border-background-200 flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-primary-500 shrink-0"></i>
                <span>{row.aigam}</span>
              </div>
            </div>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
}